import { render, staticRenderFns } from "./ECProposalInsureds.vue?vue&type=template&id=4dd97217"
import script from "./ECProposalInsureds.vue?vue&type=script&lang=js"
export * from "./ECProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports